export const UI_R14_GOLD_FLAG = "uiR14Gold" as const;
export const UI_R14_GOLD_ENV = "VITE_UI_R14_GOLD" as const;

export interface UiR14GoldFlagSources {
  explicit?: boolean;
  search?: string;
  environment?: string;
  allowQueryEnable?: boolean;
}

const ENABLED_VALUES = new Set(["1", "true", "on", "yes", "enabled"]);
const DISABLED_VALUES = new Set(["0", "false", "off", "no", "disabled"]);

function parseFlagValue(value: string | null | undefined): boolean | undefined {
  if (value == null) return undefined;

  const normalized = value.trim().toLowerCase();
  if (ENABLED_VALUES.has(normalized)) return true;
  if (DISABLED_VALUES.has(normalized)) return false;
  return undefined;
}

/**
 * Resolves the R14 visual candidate fail-closed.
 *
 * - explicit false and a query false are immediate kill switches;
 * - production enablement comes only from the build environment;
 * - query enablement is accepted only in DEV/TEST;
 * - an invalid query value disables the candidate instead of falling through;
 * - the default is OFF.
 */
export function resolveUiR14GoldFlag(
  sources: UiR14GoldFlagSources = {},
): boolean {
  if (sources.explicit === false) return false;

  const environmentEnabled = parseFlagValue(sources.environment) === true;
  const query = new URLSearchParams(sources.search ?? "");

  if (query.has(UI_R14_GOLD_FLAG)) {
    const queryValue = parseFlagValue(query.get(UI_R14_GOLD_FLAG));
    if (queryValue === false || queryValue === undefined) return false;
    if (sources.allowQueryEnable === true) return true;
  }

  if (sources.explicit === true) return true;
  return environmentEnabled;
}

export function isUiR14GoldEnabled(explicit?: boolean): boolean {
  return resolveUiR14GoldFlag({
    explicit,
    search: typeof window === "undefined" ? "" : window.location.search,
    environment: import.meta.env.VITE_UI_R14_GOLD,
    allowQueryEnable: import.meta.env.DEV || import.meta.env.MODE === "test",
  });
}
